export const TEMPLATE_TYPE = {
  HEADER: "HEADER",
  BODY: "BODY",
  FOOTER: "FOOTER"
};